// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-config .title[data-v-16554868]{position:relative}.layout-config .title .extra[data-v-16554868]{position:absolute;right:10px;top:0}", ""]);
// Exports
module.exports = exports;
